import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASEURL;

const authHeaders = () => ({
  Authorization: localStorage.getItem('token'),
});

export default {
  async list(userId, opts = {}) {
    const params = new URLSearchParams();
    if (opts.status)       params.set('status', opts.status);
    if (opts.spawned_from) params.set('spawned_from', String(opts.spawned_from));
    if (opts.limit)        params.set('limit', String(opts.limit));

    const qs = params.toString();
    const url = `${API_BASE}/api/trading_bots${qs ? `?${qs}` : ''}`;

    const response = await axios.get(url, { headers: authHeaders() });
    return response.data;
  },

  async getUserHistories(userId) {
    const response = await axios.get(
      `${API_BASE}/api/userhistory/all_by_user/${userId}`,
      { headers: authHeaders() }
    );
    return response.data;
  },

  async create(botData) {
    const response = await axios.post(
      `${API_BASE}/api/trading_bots`,
      botData,
      { headers: authHeaders() }
    );
    return response.data;
  },

  async update(id, updates) {
    const response = await axios.put(
      `${API_BASE}/api/trading_bots/${id}`,
      updates,
      { headers: authHeaders() }
    );
    return response.data;
  },

  async delete(id) {
    await axios.delete(
      `${API_BASE}/api/trading_bots/${id}`,
      { headers: authHeaders() }
    );
  },

  async backtest(id, params) {
    const response = await axios.post(
      `${API_BASE}/api/trading_bots/${id}/backtest`,
      params,
      { headers: authHeaders() }
    );
    return response.data;
  },
};